import { Flex } from '@chakra-ui/react';
import { FC } from 'react';
import PeOffersShortGridItem, { PeOrderShortGridItem } from './PeOffersShortGridItem';

interface Props {
  orders: PeOrderShortGridItem[];
  onCardClick: (orderId: ID) => void;
  itemsCountPerRow?: number;
}

const PeOffersShortGrid: FC<Props> = ({
  orders,
  onCardClick,
  itemsCountPerRow = 3,
}) => {
  const gapBetweenCards = 16;

  return (
    <Flex w="100%">
      {orders.map((order, index) => (
        <PeOffersShortGridItem
        key={index}
          peOrder={order}
          mr={
            (index + 1) % itemsCountPerRow === 0 ? '0' : `${gapBetweenCards}px`
          }
          w={`calc(100% / ${itemsCountPerRow} - ${gapBetweenCards / 2}px)`}
          onCardClick={onCardClick}
        />
      ))}
    </Flex>
  );
};

export default PeOffersShortGrid;
